import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { htmlSafe, type SafeString } from '@ember/template';
import { and, notEq } from 'ember-truth-helpers';
import getNumberSignClass from 'lumen/helpers/get-number-sign-class';

interface MarketTotalRevenueCellsTdChangeWithRelativeSignature {
  Args: {
    displayValue?: {
      change: string | SafeString;
      relativeChange: string | SafeString;
    };
    value?: number;
  };
}

const MarketTotalRevenueCellsTdChangeWithRelative = <template>
  {{#if (and (notEq @value undefined) (notEq @displayValue undefined))}}
    <div class={{getNumberSignClass @value}} data-test-id="td-change">
      {{htmlSafe
        (concat @displayValue.change " (" @displayValue.relativeChange ")")
      }}
    </div>
  {{/if}}
</template> satisfies TOC<MarketTotalRevenueCellsTdChangeWithRelativeSignature>;

export default MarketTotalRevenueCellsTdChangeWithRelative;
